import { Box } from "@mui/material";
import React from "react";

const Modal = (propse) => {
  const onClick = () => {
    propse.setShowModal({
      SHOW: false,
      PM1: "",
      PM2: "",
      PM3: "",
    });
    propse.setLoading(false);
  };

  return (
    <React.Fragment>
      <Box
        sx={{
          position: "fixed",
          width: "100%",
          height: "100vh",
          backgroundColor: "rgba(0,0,0,0.5)",
          zIndex: "1000",
          display: propse.ShowModal.SHOW ? "flex" : "none",
          flexDirection: "column",
          textAlign: "center",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            width: propse.Width < 560 ? "80%" : "380px",
            height: "220px",
            backgroundColor: "#FFF",
            borderRadius: "10px",
            display: "flex",
            flexDirection: "column",
            fontFamily: "Poppins",
            fontSize: "0.8rem",
            color: "rgba(0,0,0,0.8)",
          }}
        >
          <Box
            sx={{
              width: "calc(100% - 50px)",
              height: "50px",
              display: "flex",
              flexDirection: "row",
              justifyContent: "start",
              alignItems: "center",
              marginLeft: "25px",
              fontSize: "1rem",
              fontWeight: "bolder",
            }}
          >
            <span style={{ marginTop: "30px" }}>Attention</span>
          </Box>
          <Box
            sx={{
              width: "calc(100% - 50px)",
              height: "100px",
              display: "flex",
              flexDirection: "row",
              justifyContent: "start",
              alignItems: "center",
              marginLeft: "25px",
              textAlign: "left",
            }}
          >
            <span>
              {propse.ShowModal.PM1}
              <label
                style={{
                  marginLeft: "5px",
                  marginRight: "5px",
                  borderBottom: "1px dotted #000",
                }}
              >
                {propse.ShowModal.PM2}
              </label>
              {propse.ShowModal.PM3}
            </span>
          </Box>
          <Box
            sx={{
              width: "calc(100% - 50px)",
              height: "70px",
              display: "flex",
              flexDirection: "row",
              justifyContent: "end",
              alignItems: "center",
              marginLeft: "25px",
            }}
          >
            <Box
              sx={{
                width: "80px",
                height: "40px",
                backgroundColor: "#ed013e",
                display: "flex",
                flexDirection: "column",
                textAlign: "center",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "5px",
                cursor: "pointer",
                color: "#FFF",
                marginTop: "-25px",
              }}
              onClick={onClick}
            >
              OK
            </Box>
          </Box>
        </Box>
      </Box>
    </React.Fragment>
  );
};

export default Modal;
